import ContactForm from "%/dynamic-component-editor/standard-pages/contact-us-page/ContactForm.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyContactUs extends LegacyEntity {
  get elements() {
    return {
      ContactForm,
    };
  }
}
